import { render, staticRenderFns } from "./Xl-img.vue?vue&type=template&id=1d863c22&scoped=true"
import script from "./Xl-img.vue?vue&type=script&lang=js"
export * from "./Xl-img.vue?vue&type=script&lang=js"
import style0 from "./Xl-img.vue?vue&type=style&index=0&id=1d863c22&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d863c22",
  null
  
)

export default component.exports